<template>
  <div class="input-search">
    <el-autocomplete
      ref="input"
      v-model="agValue"
      class="inline-input"
      :fetch-suggestions="querySearch"
      :trigger-on-focus="false"
      style="width: 100%"
      size="mini"
      :placeholder="placeholder"
      @focus="focus"
      @keyup.native="tabCell"
    >
      <i
        v-if="!search"
        slot="suffix"
        class="el-icon-search"
        @click="handleIconClick"
      />
      <i slot="suffix" class="el-icon-circle-close" @click="clear" />
    </el-autocomplete>

    <local-dialog-table
      ref="table"
      :title="title"
      :append-to-body="true"
      :visible.sync="visible"
      :req-config="reqConfig"
      :column-defs="gridOptions.columnDefs"
      :show-pagination="true"
      :radio="false"
      :required="false"
      :show-search="true"
      :custom-select="false"
      @selectChange="onSelectionChangedData"
      @afterFetch="afterFetch"
      @onSelect="onSelect"
    />
  </div>
</template>

<script>
import localDialogTable from '../../DialogTable'
import agEditorMixins from './ag-editor-mixins'

export default {
  name: 'AgInputSelect',
  components: { localDialogTable },
  mixins: [agEditorMixins],
  props: {
  },
  data() {
    return {
      isFocus: true,
      tableSelectData: [],
      allSelect: [],
      visible: false,
      filterVal: [
        { value: '@{ALL}' },
        { value: '@{CURRENTUSER}' },
        { value: '@{CURRENTSTAFF}' },
        { value: '@{CURRENTORG}' },
        { value: '@{CURRENTROLE}' },
        { value: '@{CURRENTCUSTOMER}' },
        { value: '@{CURRENTCORP}' },
        { value: '@{CURRENTCOST}' }
      ]
    }
  },
  computed: {
    componentProps() {
      return Object.assign(
        {},
        {
          placeholder: this.$t('components.pleaseEnter'),
          title: ''
        },
        this.params?.cellEditorComponentProps || {}
      )
    },
    placeholder() {
      return this.componentProps.placeholder
    },
    reqConfig() {
      return this.componentProps.reqConfig
    },
    gridOptions() {
      return this.componentProps.gridOptions
    },
    title() {
      return this.componentProps.title
    },
    search() {
      return this.componentProps.search
    }
  },
  mounted() {
    this.$nextTick(() => {
      const { autoFocus } = this.componentProps
      if (autoFocus) {
        this.$refs.input.focus()
      }
    })
  },
  methods: {
    triggerChange() {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { change } = cellEditorComponentProps || {}

      change?.(this.agValue, { agParams: restAgParams })
    },
    triggerSelect(value) {
      const { cellEditorComponentProps, ...restAgParams } = this.params || {}

      const { select } = cellEditorComponentProps || {}

      select?.(value, { agParams: restAgParams })
    },
    clear() {
      this.agValue = ''
      this.triggerChange()
    },
    handleIconClick(event) {
      this.isFocus = false
      event.preventDefault()
      this.visible = true
    },
    onSelectionChangedData(ref) {
      console.log('ref', ref)
      // 获取当前分页数据
      const pageNo = this.$refs.table.pagination.pageNo
      // 当前页选中值对象
      // const selectedNodes = ref.getSelectedNodes()
      ref.forEachNode((node, index) => {
        if (node.selected) {
          this.allSelect.push(node)
        } else {
          this.allSelect.map((item, index_) => {
            if (node.data.sId === item.data.sId) {
              this.allSelect.splice(index_, 1)
            }
          })
        }
      })
      this.allSelect = this.allSelect.length > 0 ? unique(this.allSelect) : []
      function unique(arr) {
        var i
        var j
        var len = arr.length
        for (i = 0; i < len; i++) {
          for (j = i + 1; j < len; j++) {
            if (arr[i].data.sId === arr[j].data.sId) {
              arr.splice(j, 1)
              len--
              j--
            }
          }
        }
        return arr
      }
      // 取出当前分页中所选中的值
      const selectedData =
        this.allSelect && this.allSelect.map((node) => node.data)
      this.tableSelectData[pageNo] = selectedData
      // 所有选中的值
      this.$refs.table.selectedRightDataNodes = [].concat.apply(
        [],
        selectedData
      )
    },
    afterFetch(rowData) {
      this.complete_Data = rowData
      console.log(rowData)
      this.$refs.table.gridOptions.api.forEachNode((node) => {
        const data = [].concat.apply([], this.tableSelectData)
        data.map((item) => {
          if (item[rowData.keyField] === node.data[rowData.keyField]) {
            node.setSelected(true)
          }
        })
      })
    },
    handleClose(value = []) {
      this.triggerSelect(value)
    },
    onSelect(option, type) {
      if (type === 'confirm') {
        this.agValue = {
          option: option,
          data: this.complete_Data
        }
      }
      // this.handleClose()
      this.allSelect = []
      this.arr = []
      this.visible = false
    },
    // 失焦事件
    blurAction(e) {
      this.triggerBlur(e)
    },
    tabCell(e) {
      this.triggerKeyup(e)
    },
    querySearch(queryString, cb) {
      const filterVal = this.filterVal
      const results = queryString
        ? filterVal.filter(this.createFilter(queryString))
        : filterVal
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (filterVal) => {
        return (
          filterVal.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        )
      }
    }
  }
}
</script>

<style scoped lang="scss">
.input-search {
  .el-icon-search,
  .el-icon-circle-close {
    cursor: pointer;
    margin: 0 1px;
  }
}
</style>
